module.exports = __webpack_public_path__ + "img/바이킹.123d7930.png";